const selectors = {
  bannerNavigation: "banner-navigation",
  contentBanner: "site-banner",
};
export default selectors;
